module.exports = __webpack_public_path__ + "img/playlist_add-24px.774a5c6b.svg";